export const sharedEn = {
	shared: {
		common: {
			scrollHint: 'Scroll down',
		},
	},
}
